import { KrtiPayService } from './api'


const krtiWebUrl = process.env.REACT_APP_WEB_BASE_URL;


export const getLanguagelist = async (requestBody) => {
    const { offset, limit, user_id, brand_id, search, startDate, endDate,statusfilter } = requestBody
    try {
        return await KrtiPayService.get(`${krtiWebUrl}/language-management/getAllLanguages/?offset=${offset}&limit=${limit}&search=${search}&statusfilter=${statusfilter}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const CreateLanguage = async (req) => {
    try {
        return await KrtiPayService.post(`${krtiWebUrl}/language-management/add-language
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const getAllLanguages = async (requestBody) => {
    try {
        return await KrtiPayService.get(`${krtiWebUrl}/language-management/getLanguagesList`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const LanguageStatusupdate = async (req) => {
    // const {i} = payload
    try {
        return await KrtiPayService.post(`${krtiWebUrl}/language-management/statusUpdate/${req?.id}/${req?.status}/
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const updateLanguage = async (req) => {
    // const {i} = payload
    try {
        return await KrtiPayService.post(`${krtiWebUrl}/language-management/set-language
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const GetMerchantCategory = async (selectedMerchant) => {

    try {
        return await KrtiPayService.get(`${krtiWebUrl}/category/getmerchantCategory/${selectedMerchant}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}